import { gql } from "apollo-boost"

export const GET_PROJECT_ASSISTANTS_AND_COUNT = gql`
  query getProjectAssistantsAndCount($id: ID!, $skip: Float, $first: Float, $filter: String, $sortingBy: AssistantsOrderBy, $sortingOrder: SortingOrder, $filterBy: [AssistantsFilterByInput!]) {
    projectAssistantsCount(id: $id, filter: $filter, filterBy: $filterBy)
    ProjectAssistants (id: $id, first: $first, skip: $skip, filter: $filter, sortingBy: $sortingBy, sortingOrder: $sortingOrder, filterBy: $filterBy){
      id
      name
      curp
      phone
      state
      folio
      gender
      colony
      lastName
      birthdate
      maidenName
      beneficiary
      municipality
      beneficiaryProfileId
      documents {
        id
        name
        url
      }
      assistance {
        id
        hasAssist
        assistanceAt
        activitySchedule {
          id
          startTime
        }
        activity {
          id
          description
          title
        }
      }
    }
  }
`
